module.exports = __webpack_public_path__ + "static/media/ic_pencil.86a79636.svg";